module.exports = __webpack_public_path__ + "static/media/froggytalk.d8b56193.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/froggytalk.webp
// module id = 634
// module chunks = 0